module.exports = __webpack_public_path__ + "img/far_night_cyl75_axis45.9c35c475.jpg";